import { render } from "./ScrollTabsBar.vue?vue&type=template&id=67e96eda&scoped=true"
import script from "./ScrollTabsBar.vue?vue&type=script&lang=js"
export * from "./ScrollTabsBar.vue?vue&type=script&lang=js"

import "./ScrollTabsBar.vue?vue&type=style&index=0&id=67e96eda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e96eda"]])

export default __exports__